export enum SESSION_STORAGE_KEYS {
	SEGMENT_LAST_SENT_HASH_KEY = 'HIGHLIGHT_SEGMENT_LAST_SENT_HASH_KEY',
	SESSION_ID = 'sessionID',
	SESSION_DATA = 'sessionData',
	USER_IDENTIFIER = 'highlightIdentifier',
	USER_OBJECT = 'highlightUserObject',
}
